import { render } from "./SliderMainMobile2.vue?vue&type=template&id=3dd77dd2&scoped=true"
import script from "./SliderMainMobile2.vue?vue&type=script&lang=js"
export * from "./SliderMainMobile2.vue?vue&type=script&lang=js"

import "./SliderMainMobile2.vue?vue&type=style&index=0&id=3dd77dd2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dd77dd2"]])

export default __exports__